import {
    Row,
    Col
} from "reactstrap";
// import { useNavigate } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import { getOneAccount, updateAccount } from "../services/accountService";
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
// import utils from "../../../utils/utils";
import FullLayout from '../layouts/FullLayout';

// import Pagination from "../../../components/Pagination";
import Toast from 'react-bootstrap/Toast';
import { useState, useEffect, useContext } from "react";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
// import DeleteModal from "../../../components/DeleteModal";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


export default function Settings() {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const [nameError, setNameError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [phoneError, setPhoneError] = useState('')

    const [isEditable, setIsEditable] = useState(false); 

  // const toast: any = useContext(ToastContext);
    const [show, setShow] = useState(false);
    const [successValue, setSuccessValue] = useState("");
    const [message, setMessage] = useState("")


    const toast = useContext(AlertContext);
 useEffect(() => {
        // if (id) {
        fetchOneSetting();
        // }
    }, []);

    async function fetchOneSetting() {
        try {
            // const token =localStorage.getItem('jwtToken');
            // console.log('token',token)
            const response = await getOneAccount();
            console.log('response fetchOne', response)
            const responseData = response?.data?.data;
            console.log('responseData....jkhj', responseData)
            if (response?.status === 200) {

                console.log('responseData', responseData)
                setName(responseData.name)
                setEmail(responseData.email)
                setPhone(responseData.phone)

            }
        } catch (error) {
            console.error("Error:", error);
        }
    }
    const handleChangename = (event) => {
        setName(event.target.value)
        if (nameError !== "") {
            setNameError("")
        }
    }
    const handleChangeemail = (event) => {
        setEmail(event.target.value)
        if (emailError !== "") {
            setEmailError("")

        }
    }
    const handleChangephone = (event) => {
        setPhone(event.target.value)
        if (phoneError !== "") {
            setPhoneError("")
        }
    }

    //update
    async function handleEdit() {
        try {
           
            const response = await updateAccount(name, email, phone);
            console.log('response formdata', response)
            const responseData = response?.data;
            let theme = "success"

        if (response?.status === 200) {
                // showToast("Profile Updated Successfully!")
                setIsEditable(false);
                console.log('responseData edit..', responseData)
               
            } else {
                theme = "danger"
                console.log("error", response)
            }
            window.scrollTo(0, 0);
            setShow(true);
            setMessage(responseData.message);
            setSuccessValue(theme);
        } catch (error) {
            console.error("Error:", error);
        }
    }


    return (
        <FullLayout
        >

            <Row>
                <div className="panel_top_section ">
                    <h1>My Account</h1>
                    <i className="bi bi-pencil fs-3 ms-3" onClick={() => setIsEditable(!isEditable)} ></i>

                </div>
                <Col>
                    <Form
                    // onSubmit={handleSubmit}
                    >
                        
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url" className="mt-3">Name</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangename} value={name} disabled={!isEditable} />
                            </InputGroup>
                            {nameError ? <span className="text-danger">{nameError}</span> : ""}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">Email</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" onChange={handleChangeemail} value={email} disabled={!isEditable} />
                            </InputGroup>
                            {emailError ? <span className="text-danger">{emailError}</span> : ""}


                        </Form.Group>


                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">Phone</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangephone} value={phone} disabled={!isEditable} />

                            </InputGroup>
                            {phoneError ? <span className="text-danger">{phoneError}</span> : ""}

                        </Form.Group>
                        {isEditable && (
                        <button
                            className="btn_gradian ms-3 mt-3"
                            type="submit"
                        onClick={handleEdit}
                        >
                            Update
                        </button>
)}
                    </Form>
                </Col>
                {show &&
                    <Toast className={successValue === "success" ? "float-start end-0 position-absolute show bg-success z-3" : "float-start end-0 position-absolute show bg-danger z-3"} style={{ top: "0px" }}>
                        <Toast.Header className={`show ${successValue === "success" ? "bg-success" : "bg-danger"}`}>
                            <strong className="me-auto text-white">Success Message</strong>
                        </Toast.Header>
                        <div aria-live="polite" aria-atomic="true" className="d-flex justify-content-center align-items-center w-100 mb-10 text-white bg-transparent">
                            <div className="fade toast show  bg-transparent" role="alert" aria-live="assertive" aria-atomic="true">
                                <div className="fade toast show bg-transparent p-4 text-white">
                                    {message}
                                </div>
                            </div>
                        </div>
                    </Toast>
                }
            </Row >

        </FullLayout>
    )
}